export default __webpack_public_path__ + "aa1e4c11e8a68b5452aa802b861071d9.png";